import React from 'react';
import { Button, Input, Icon } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import { errorInput } from 'src/components/helpers';
import useRememberCredentials from 'src/components/helpers/useRememberCredentials';
import RememberCredentialsCheckbox from 'src/components/helpers/RememberCredentialsCheckbox';
import FieldLabel from './FieldLabel';
import { FormCard, FlowHeader } from '../styles';
import styled from '@emotion/styled';

const PreloginForm = styled(FormCard)`
  .conexion-remember {
    margin: 0 0 1.25rem;
    max-width: none;
  }
`;

const PreloginStep = ({ onContinue, lookupNewMember }) => {
  const [inputs, setInputs] = React.useState({
    identification: '',
    phone: '',
  });
  const [errorInputs, setErrorInputs] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const { rememberCredentials, setRememberCredentials, persistCredentials } =
    useRememberCredentials({ setInputs });

  const verifyForm = () => {
    let nextErrorInputs = {};
    ['identification', 'phone'].forEach((input) => {
      nextErrorInputs = errorInput({
        errorInputs: nextErrorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    if (inputs.identification && String(inputs.identification).length <= 5) {
      nextErrorInputs = errorInput({
        errorInputs: nextErrorInputs,
        input: {
          name: 'identification',
          value: String(inputs.identification).length >= 5,
        },
      });
    }

    if (inputs.phone && String(inputs.phone).length <= 10) {
      nextErrorInputs = errorInput({
        errorInputs: nextErrorInputs,
        input: {
          name: 'phone',
          value: String(inputs.phone).length >= 10,
        },
      });
    }

    setErrorInputs(nextErrorInputs);
    return Object.values(nextErrorInputs).includes(true);
  };

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
    setErrorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;

    setLoading(true);

    persistCredentials({
      identification: inputs.identification,
      phone: inputs.phone,
    });

    try {
      const result = await lookupNewMember({
        identification: inputs.identification,
        phone: inputs.phone,
      });
      if (!result) return;

      const { data, attendant } = result;

      if (data.alreadySubmitted && !data.guest) {
        Swal.fire(data.message || 'Ya respondiste este formulario recientemente.');
        return;
      }

      if (data.finded && !data.match && data.message) {
        await Swal.fire({
          icon: 'info',
          title: 'Verifica tus datos',
          text: data.message,
        });
      }

      onContinue(attendant);
    } finally {
      setLoading(false);
    }
  };

  const hasErrors = Object.values(errorInputs).includes(true);

  return (
    <PreloginForm className="Registration__form" onSubmit={handleSubmit}>
      <FlowHeader>
        <h1>¡Bienvenido a Casa!</h1>
        <p className="flow-intro">Ingresa tu identificación y celular para continuar.</p>
      </FlowHeader>

      {hasErrors && <p className="form-errors">Por favor verifica los campos marcados.</p>}

      <div className="form-section">
        <FieldLabel required>Identificación</FieldLabel>
        <div className="form-field">
          <Input
            fluid
            type="number"
            name="identification"
            id="identification"
            placeholder="Número de identificación"
            value={inputs.identification}
            onChange={handleInputs}
            className={errorInputs.identification ? 'error' : ''}
          />
        </div>
      </div>

      <div className="form-section">
        <FieldLabel required>Celular</FieldLabel>
        <div className="form-field">
          <Input
            fluid
            type="number"
            name="phone"
            id="phone"
            placeholder="Número de celular"
            value={inputs.phone}
            onChange={handleInputs}
            className={errorInputs.phone ? 'error' : ''}
          />
        </div>
      </div>

      <RememberCredentialsCheckbox
        checked={rememberCredentials}
        onChange={setRememberCredentials}
        className="conexion-remember"
      />

      <div className="submit-actions">
        <Button type="submit" primary disabled={loading} loading={loading}>
          Continuar <Icon name="chevron right" />
        </Button>
      </div>
    </PreloginForm>
  );
};

export default PreloginStep;
